/**
 * 组织权限接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DepartmentJurisdictionService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 组织权限接口
  /**
   * 查询组织树
   * @param param
   * @returns {Observable<any>}
   */
  queryOrganizeTree(param) {
    const url = this.prefix + 'organize/queryTree';
    return this.http.Post(url, param);
  }

    /**
   * 查询用户组织中间表
   * @param param
   * @returns {Observable<any>}
   */
  queryOrganizeByFk(param) {
    const url = this.prefix + 'roleOrganize/queryByFk';
    return this.http.Post(url, param);
  }

      /**
   * 角色组织关联保存
   * @param param
   * @returns {Observable<any>}
   */
  saveRoleOrganize(param) {
    const url = this.prefix + 'roleOrganize/saveOrDelete';
    return this.http.Post(url, param);
  }
  //#endregion
}
